import React, { useState, useEffect } from "react";
import CartItem from "../../components/CartItem/CartItem";
import "./Cart.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
// import { toast } from "react-hot-toast";
import { toast } from "react-toastify";

import Loaderdots from "../../components/LoaderDots/Loaderdots";
import NoData from "../../components/NoData/NoData";
import Swal from "sweetalert2";
import { cartEmty } from "../../Assests/Assests";



export const Cart = () => {
  const [cartItems, setCartItems] = useState([]);
  // const [userCartDetails, setUserCartDetails] = useState([])
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
 
  // useEffect(() => {
  //   // Show toast message when the component mounts
  //   toast.info("TRY and BUY is Available For Some Pincodes.", {
  //     position: "top-right",
  //     autoClose: 5000, // Closes after 5 seconds
  //     hideProgressBar: false,
  //     closeOnClick: true,
  //     pauseOnHover: true,
  //     draggable: true,
  //     theme: "colored",
  //     className: "custom-toast",
  //   });
  // }, []);

  useEffect(() => {
    
    const fetchCartItems = async () => {
      try {
        const response = await fetch(
          `https://riymay.com/api/v1/user/cart/`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${localStorage.getItem("userToken")}`,
            },
          }
        );

        const result = await response.json();

        if( result.message == "email is not verified"){
          try {
            const token = localStorage.getItem("userToken")
            // Call the resend OTP API
            const resendResponse = await fetch("https://riymay.com/api/v1/user/resend/verification/email", {
              method: "POST",
              headers: {
                "Content-Type": "application/json", 
              },
              body: JSON.stringify({token}),
            });  
      
            const resendData = await resendResponse.json();
      
            if (resendData.success) {
              toast.success("✅ OTP resent successfully!", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                className: "custom-toast",
        bodyClassName: "custom-toast-body",
              });
              
              // Delay navigation until after the toast is shown
              setTimeout(() => {
                navigate("/resend-otp");
              }, 3000);
              
            } else {
              setError(resendData.message || "Failed to resend OTP");
              toast.error(resendData.message || "❌ Failed to resend OTP", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                className: "custom-toast",
                bodyClassName: "custom-toast-body",              });
                          }
          } catch (error) {
            setError("An error occurred while resending OTP");
            toast.error("An error occurred while resending OTP", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              className: "custom-toast",
              bodyClassName: "custom-toast-body",            });
            
          }
        }
        if(result.message == "Invalid token" || result.message == "Invalid or expired token"){
          localStorage.removeItem("userToken")
          navigate("/login")
        }
      

        if (!response.ok) {
          
          throw new Error("Failed to fetch cart items");
        }

         
        
        setCartItems(result.cartItems || []);
        // toast.info("TRY and BUY is Available For Some Pincodes.", {
        //   position: "top-right",
        //   autoClose: 5000, // Closes after 5 seconds
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   theme: "colored",
        //   className: "custom-toast",
        // });
      } catch (error) {
        console.error("Error fetching cart items:", error);
      }
    };

    fetchCartItems();
    handleDiscountChange()
  }, []);

  // useEffect(() => {
  //   const fetchUser = async() => {
  //     const response  = await fetch(
  //        `https://riymay.com/api/v1/user/getuserdetails`,
  //         {
  //           method: "GET",
  //           headers: {
  //             Authorization: `Bearer ${localStorage.getItem("userToken")}`,
  //             "Content-Type": "application/json",
  //           },
  //         }
  //     )
  //     const result = await response.json();

      // if(result.message == "Invalid token" || result.message == "Invalid or expired token"){
      //   localStorage.removeItem("userToken")
      //   navigate("/login")
      // }
      // if (!response.ok) {
      //   throw new alert("Failed to fetch user data");
      // }

  //       // Extract cart items with coupon details
  //       const updatedCartItems = result.user.cart.map((item) => ({
  //         ...item,
  //         couponCode: item.couponCode || "", 
  //         discountAmount: item.discountAmount || 0, 
  //       }));


  //     setUserCartDetails(updatedCartItems)
  //   }
  //   fetchUser()
  // }, []) 

  // const handleCheckout1 = () => {
  //   if (!enteredPincode) {
  //     toast.error("Please enter a valid pincode.", {
  //       position: "top-right",
  //       autoClose: 3000, // Closes after 3 seconds
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       theme: "colored",
  //       className: "custom-toast",
  //     });
  //     return;
  //   }

    const handleIncrease = async (productId, size, color) => {
    try{
    const makeAPI = await fetch(`https://riymay.com/api/v1/user/cart`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("userToken")}`,
      },
      body: JSON.stringify({ productId, size, color }),
    });
    const responseAPI = await makeAPI.json();
    if (makeAPI.ok) {
      console.log(setCartItems, "discount ================")
      setCartItems((prevItems) =>
        prevItems.map((item) =>
          item._id === productId && item.size === size
            ? { ...item, quantity: item.quantity + 1 }
            : item
        )
      );
    }
  }catch(err){
    console.error(err.message);
  }
}

  const handleDecrease = async (productId, size, color) => {
    try {
      const makeAPI = await fetch(`https://riymay.com/api/v1/user/cart`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
        body: JSON.stringify({ productId, size, color }),
      });
      const responseAPI = await makeAPI.json();
      if (makeAPI.ok) {
        setCartItems((prevItems) =>
          prevItems.map((item) =>
            item._id === productId && item.size === size && item.quantity > 1
              ? { ...item, quantity: item.quantity - 1 }
              : item
          )
        );
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  const handleRemove = async (productId, size, color) => {
    try {
      const response = await fetch("https://riymay.com/api/v1/user/cart", {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ productId, size, color }),
      });
      const result = await response.json();
      // console.log(result);
      if (response.ok) {
        localStorage.removeItem(`coupon_${productId}_${size}`);
        setCartItems((prevItems) =>
          prevItems.filter(
            (item) => !(item._id === productId && item.size === size)
          )
        );
      }
    } catch (error) {
      console.error("Error removing item:", error.message);
    }
  };

  
  const handleDiscountChange = (productId, size, discountAmount, couponCode) => {
    setCartItems((prevItems) =>
      prevItems.map((item) =>
        item._id === productId && item.size === size
          ? { ...item, discountAmount, couponCode }
          : item
      )
    );
  };

  
  const totalQuantity = cartItems.reduce((acc, item) => acc + item.quantity, 0);
  const totalPrice = cartItems.reduce(
    (acc, item) => acc + item.quantity * (item.price - (item.discountAmount || 0)),
    0
  );


  // const handlePincodeChange = (event) => {
  //   setSelectedPincode(event.target.value);

   
  // };

   const location = useLocation(); // Detects route changes
    const toastId = "welcome-toast"; // Unique toast ID


    useEffect(() => {
      // Prevent duplicate toasts by checking if the toast is already active
      if (!toast.isActive(toastId)) {
        toast.success(
          <div>
            <h4 style={{ fontSize: "1rem", marginBottom: "0.5rem" }}>
              Welcome to Cart!
            </h4>
            <p>
            {" "}
              <span style={{ fontWeight: "bold", color: "#47663B" }}>TRY</span> &{" "}
              <span style={{ fontWeight: "bold", color: "#47663B" }}>BUY</span>{" "}
              is Available For Some Pincodes Only.
            </p>
          </div>,
          {
            toastId, // Ensures uniqueness
            position: "top-left",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            // progressStyle: { backgroundColor: "#1f4629" },
            className: "custom-toast",
        bodyClassName: "custom-toast-body",
            // theme: "",
          }
        );
      }
  
      // Cleanup function to dismiss toast when page changes
      return () => {
        // toast.dismiss(toastId);
      };
    }, [location]); // Runs when the route changes

  if (loading) return <Loaderdots />
  if (error) return <NoData />;

  const totalDiscount = cartItems.reduce((acc, item) => acc + (item.discountAmount || 0) * item.quantity, 0);

  return (
    <>
    <div className="cart-container">
      <h3 className="cart-page-title">Shopping Cart</h3>

      {cartItems && cartItems.length === 0 ? (
        <div className="cart-empty-state">
          <p className="nodata-label">Your cart is empty</p>
          <p className="nodata-sub">Add something to get started.</p>
          <Link to="/newproduct" className="nodata-btn">Continue Shopping</Link>
        </div>
      ) : (
        <div className="cart-shell">
          <div className="cart-shell-head">
            <h3>Cart</h3>
            <span>{totalQuantity} {totalQuantity === 1 ? "item" : "items"}</span>
          </div>

          {cartItems.map((item) => (
            <CartItem
              key={`${item._id}-${item.size}`}
              item={item}
              onIncrease={() => handleIncrease(item._id, item.size, item.color)}
              onDecrease={() => handleDecrease(item._id, item.size, item.color)}
              onRemove={() => handleRemove(item._id, item.size, item.color)}
              onDiscountChange={handleDiscountChange}
            />
          ))}

          <div className="cart-bar">
<div className="cart-bar-section">
              <div className="cart-bar-label">Items</div>
              <div className="cart-bar-val">{totalQuantity}</div>
            </div>
            {totalDiscount > 0 && (
              <div className="cart-bar-section">
                <div className="cart-bar-label">Saved</div>
                <div className="cart-bar-val saving">₹{totalDiscount.toFixed(0)}</div>
              </div>
            )}
            <div className="cart-bar-section">
              <div className="cart-bar-label">Total</div>
              <div className="cart-bar-val">₹{totalPrice.toFixed(0)}</div>
            </div>
            <button className="checkout-button-2" onClick={() => navigate('/shipping-address', { state: { pincode: 'N/A', totalQuantity: totalQuantity, totalPrice: totalPrice} })}>
              Checkout
            </button>
          </div>
        </div>
      )}
    </div>
    </>
  );
};
